import { createContext } from 'react'

export const FloatingSelectContext = createContext(null)
